// extracted by mini-css-extract-plugin
export var bg = "OptionsPopup-module--bg--xxH+k";
export var closeButton = "OptionsPopup-module--closeButton--oR-L5";
export var container = "OptionsPopup-module--container--6WyC3";
export var content = "OptionsPopup-module--content--0z9kG";
export var contentFullHeight = "OptionsPopup-module--contentFullHeight--qvB3S";
export var display = "OptionsPopup-module--display--yENf+";
export var header = "OptionsPopup-module--header--HLmQo";
export var overflowVisible = "OptionsPopup-module--overflowVisible--8a+b3";